module.exports = __webpack_public_path__ + "img/大荤.c73ad2e5.png";